import { Component, OnInit } from '@angular/core';
import { DatabasearchiveService } from '../../app/databasearchive/databasearchive.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DebugHelper } from 'protractor/built/debugger';
import { Databasearchive } from './databasearchive';
import * as $ from 'jquery';
import { LocalService } from '../local.service';

@Component({
    selector: 'app-databasearchive',
    templateUrl: './databasearchive.component.html',
    styleUrls: ['./databasearchive.component.css'],
    providers: [ToastrService]
})
export class DatabasearchiveComponent implements OnInit {
    mailtemplateForm: FormGroup;
    _mailGroupListtmp: any = [];
    _mailGroupList: any = [];
    _DataBase: any = [];
    _mailTempList: any;
    _groupMapped: any = [];
    _dropdownSettings: any;
    username: any;
    dpConfig: any; bsInlineValue: any;
    documentinfodesiredCompDateValue: any;
    documentinfodesiredCompDateValue1: any;
    public yeardata = [];
    public settings = {};
    public selectedItems = [];

    onMailGroupItemDeSelect: any;
    onMailGroupItemSelect: any;
    userid: any;
    mailTemps: Databasearchive[];

    _mailGroupListtmp1: any = [];
    _mailGroupList1: any = [];
    _selectedState: any = [];

    _mailTempList1: any;
    _groupMapped1: any = [];
    _dropdownSettings1: any;

    _mailGroupListtmp2: any = [];
    _mailGroupList2: any = [];
    _selectedArchYear: any = [];
    _mailTempList2: any;
    _groupMapped2: any = [];
    _dropdownSettings2: any;
    myVar: boolean;
    myVar1: boolean;
    myVar4: boolean;
    myVar5: boolean;
    dropdowntext: string;
    textBoxDisabled = true;
    textBoxDisabled1 = true;

    disable_State: any;
    disable_ArchDate: any;
    $: any;
    sh_Loader: any;
    p: number = 1; public searchText: string;
    itemsPerPage: number = 10;
    searchTexttemp: any;


    constructor(private toastr: ToastrService, private databasearchiveService: DatabasearchiveService
        , private formBuilder: FormBuilder,
        private localService: LocalService) { }

    ngOnInit() {
        this.searchText = '';
        this.disable_State = false;
        this.disable_ArchDate = true;


        this.yeardata = [];

        // setting and support i18n
        this.settings = {
            singleSelection: true,
            idField: 'item_id',
            textField: 'item_text',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            maxHeight: 197,
            itemsShowLimit: 3,
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };

        this.myVar = false;
        this.myVar1 = true;
        this.myVar4 = false;
        this.myVar5 = false;

        //form validation   
        this.mailtemplateForm = this.formBuilder.group(
            {
                documentinfo__desiredcompletiondate: ['', Validators.required],
                documentinfo__desiredcompletiondate1: ['', Validators.required],
                mailgroup: ['', Validators.required],
                mailgroup1: ['', Validators.required],
                mailgroup2: ['', Validators.required],
                searchTexttemp: []

            });

        this.loadtablelist();
        this.loadarchivedata();
        this.loadstate();
        this.loadyear();
    }

    onItemSelect(item: any) {
        var substring = "Leg Info";
        var substring1 = "Reg Info";
        var substring2 = "Full Text";
        this.dropdowntext = item.mailgroup;
        if (this.dropdowntext.includes(substring) || this.dropdowntext.includes(substring1) || this.dropdowntext.includes(substring2)) {
            console.log(substring);
            this.myVar = true;
            this.myVar1 = false;
            $('#rdoState').click();//enables manual click to reset the state
            $('#rdoState').click();//needed
        }
        else {
            console.log('Others');
            this.myVar = false;
            this.myVar1 = true;
        }
        this._selectedState = null;
        this.documentinfodesiredCompDateValue = null;
    }


    resetForm() {
        this.myVar = false;
        this.myVar1 = true;

        this.disable_State = false;
        this.disable_ArchDate = true;
        this._selectedState = null;
        this.documentinfodesiredCompDateValue = null;
    }


    onItemDeSelect(item: any) {
        this.resetForm();
    }

    loadarchivedata() {
        this.sh_Loader = true;
        
        this._mailTempList = [];
        this.databasearchiveService.loadarchivedata().subscribe(
            (res) => {
                if (res != undefined) {
                    this.mailTemps = res;
                    this._mailTempList = [];
                    this.mailTemps.forEach(item => {
                        this._mailTempList.push({
                            firstname: item.firstname,
                            useraction: item.useraction,
                            dateofaction: item.dateofaction,
                            archivedate: item.archivedate,
                            description: item.description
                        });
                    });
                    this._mailTempList = this._mailTempList.reverse();
                    this.sh_Loader = false;
                }
            }, error => { this.toastr.error('Error in getting data'); this.sh_Loader = false; });

    }

    loadyear() {
        //get result in yeardata
        this.databasearchiveService.getCurrentYear().subscribe(res => {
            if (res.length > 0) {
                var tempData = [];
                tempData = res;
                var currentYear = tempData[0].currentYear;
                var previousYear = tempData[0].previousYear;
                this.yeardata = [
                    { item_id: parseInt(currentYear), item_text: currentYear },
                    { item_id: parseInt(previousYear), item_text: previousYear }
                ];
                var allData = this.yeardata;
                allData.forEach(data => {
                    this._mailGroupListtmp2.push({ item_id: data.archiveyear, item_text: data.archiveyear });
                });
                this._dropdownSettings2 = {
                    singleSelection: true,
                    idField: 'item_id',
                    textField: 'item_text',
                    selectAllText: 'Select All',
                    unSelectAllText: 'UnSelect All',
                    itemsShowLimit: 7,
                    allowSearchFilter: true
                };
                this._mailGroupList2 = JSON.parse(JSON.stringify(this._mailGroupListtmp2));

            }
        }, error => { this.toastr.error('Error in DB, getting Current Year'); }

        )
    };

    loadtablelist() {
        this.databasearchiveService.Get().subscribe(res => {
            if (res != undefined) {
                var allData = res;
                allData.forEach(data => {
                    // if (data.active != 0) {
                    this._mailGroupListtmp.push({ mailgroupid: data.tablename, mailgroup: data.formconfigname });
                    //  }
                });
                this._dropdownSettings = {
                    singleSelection: true,
                    idField: 'mailgroupid',
                    textField: 'mailgroup',
                    selectAllText: 'Select All',
                    unSelectAllText: 'UnSelect All',
                    itemsShowLimit: 7,
                    allowSearchFilter: true
                };
                this._mailGroupList = JSON.parse(JSON.stringify(this._mailGroupListtmp));
            }
        }, error => { this.toastr.error('Error in getting  list'); }

        )
    };


    loadstate() {
        this.databasearchiveService.loadstate().subscribe(res => {
            if (res != undefined) {
                var allData = res;
                allData.forEach(data => {
                    // if (data.active != 0) {
                    this._mailGroupListtmp1.push({ stateid: data.stateid, state: data.state });
                    //  }
                });
                this._dropdownSettings1 = {
                    singleSelection: true,
                    idField: 'stateid',
                    textField: 'state',
                    selectAllText: 'Select All',
                    unSelectAllText: 'UnSelect All',
                    itemsShowLimit: 7,
                    allowSearchFilter: true
                };
                this._mailGroupList1 = JSON.parse(JSON.stringify(this._mailGroupListtmp1));
            }
        }, error => { this.toastr.error('Error in getting  list'); }

        )
    };


    mailSaveStructure(list, type) {
        var temp = [];
        if (type == 'mailgroup') {
            if ((list != null) && (list.length > 0)) {
                list.forEach(item => {
                    //    temp.push({ mailgroupid: item.mailgroupid })
                    console.log(item)
                    temp.push({ table_name: item })
                })
            }
        }
        return temp;
    }


    toggle() {

        if (this.textBoxDisabled == true) {
            this.textBoxDisabled1 = this.textBoxDisabled1;
        }
        // this.textBoxDisabled = !this.textBoxDisabled;

    }

    toggle1() {
        

        this.textBoxDisabled = this.textBoxDisabled;
    }

    enableDate() {
        this.disable_State = true;
        this.disable_ArchDate = false;
        this._selectedState = null;
    }

    enableState() {
        this.disable_State = false;
        this.disable_ArchDate = true;
        this.documentinfodesiredCompDateValue = null;
    }


    //saving the mail template details in to the db
    saveTemplate() {

        var getType = "";

        this.sh_Loader = true;
        
        console.log('selectedArchYear');
        console.log(this._selectedArchYear + '   ' + this._selectedArchYear.length);

        var _groupText = {};
        //if (this.mailtemplateForm.valid) {


        if (this._selectedArchYear == null || this._selectedArchYear == 'null') {
            this._selectedArchYear = '';
        }

        if (this._selectedArchYear.length == 0) {
            this.toastr.warning('Kindly Select Archive Year!');
            this.sh_Loader = false;
        } else if (this._selectedState || this.documentinfodesiredCompDateValue || this.documentinfodesiredCompDateValue1) {



            //this.toastr.success('in');
            //return;
            if (((this._DataBase == null) || (this._DataBase.length == 0))) {
                this.toastr.error('Atleast any one table should get selected');
                this.sh_Loader = false;
                return;
            } else {
                var tempDB = this._DataBase[0].mailgroup;
                if ((tempDB.indexOf('Reg') > -1) || (tempDB.indexOf('Leg') > -1) || (tempDB.indexOf('Full Text') > -1)) {
                    if (this.disable_State == true) {
                        getType = "byDate";
                    } else if (this.disable_ArchDate == true) {
                        getType = "byState";
                    }
                }
                else {
                    getType = "byNon";
                }

                //  _groupText['mailgroups'] = this.mailSaveStructure(this._DataBase, 'mailgroup');
                this.mailtemplateForm.value.groupmapped = JSON.stringify(this._DataBase);
                //this.userid = +localStorage.getItem('userid');
                this.userid = +this.localService.getJsonValue('userid');
                this.mailtemplateForm.value.createdby = this.userid;
                //  this.mailtemplateForm.value.groupmapped = "rajeev1"
                this.mailtemplateForm.value.table_name = ""
                this.mailtemplateForm.value.groupmapped1 = JSON.stringify(this._selectedState);
                this.mailtemplateForm.value.groupmapped2 = JSON.stringify(this._selectedArchYear);
                this.mailtemplateForm.value.documentinfo__desiredcompletiondate = this.documentinfodesiredCompDateValue;
                this.mailtemplateForm.value.documentinfo__desiredcompletiondate1 = this.documentinfodesiredCompDateValue1;
                this.mailtemplateForm.value.mailgroup = ""
                this.mailtemplateForm.value.getType = getType;
                this.databasearchiveService.Post(this.mailtemplateForm.value).subscribe(
                    (res) => {
                        if (res) {
                            this.toastr.success('Archived successfully!');
                            this.mailtemplateForm.reset();
                            this.loadarchivedata();
                            this.resetForm();
                            this.sh_Loader = false;
                        }
                        else {
                            this.toastr.warning('error');
                            this.sh_Loader = false;
                        }

                    },
                    error => {
                        this.toastr.error(error);
                        this.sh_Loader = false;
                    });
            }

        } else {
            this.toastr.warning('Kindly fill all the fields!');
            this.sh_Loader = false;
        }

    }

}
